<template>
  <detail-layout-two-columns-no-fixed >
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>   
    </template>

    <template slot="LeftCol">
      <div class="form-wrapper px-4 lg:px-10 overflow-x-auto overflow-y-auto">
        <el-form :model="form.paymentMethod" ref="ruleForm" :rules="rules">
          <div class="flex-1">

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full" >
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.step6.payment_method') }}</label>
                  <el-form-item prop="formaPago" class="w-full">
                    <el-form-item prop="tipoAsociado">
                      <base-el-select class="w-full"  v-model="form.paymentMethod.formaPago" :options="formasPago" />
                    </el-form-item>
                  </el-form-item>
              </div>
            </div>

            <!-- <div v-if="false" class="lg:mb-2">
              <div >
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isRequired"/>{{ $t('invoices.invoices_issuing.nombre_cuenta') }}</label>
                <el-form-item prop="nombreCuenta">
                  <el-input
                    clearable class="w-full" v-model="form.paymentMethod.nombreCuenta" maxlength='30'
                  />
                </el-form-item>
              </div>
            </div> -->

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">
                <el-form-item prop="toBeCredit" class="switchCredit">
                  <base-obligatory-icon v-if="isRequired" />
                  <el-switch 
                    class="switch-text break-normal both-switch" 
                    v-model="form.paymentMethod.toBeCredit" 
                    :active-text="$t('invoices.invoices_issuing.iban')"
                    :inactive-text="$t('agenda.account_number')"
                    inactive-color="var(--primary-800)"/>
                </el-form-item>
              </label>
              <el-form-item prop="iban">
               <el-input
                  clearable class="w-full" v-model="form.paymentMethod.iban" maxlength='40'
                />
              </el-form-item>
            </div>

            <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.bic_swift') }}</label>
                <el-form-item prop="bicSwift">
                  <el-input
                    clearable class="w-full" v-model="form.paymentMethod.bicSwift" maxlength='14'
                  />
                </el-form-item>
            </div>

            <div v-if="isDomiciliado" class="lg:mb-2">
              <div >
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.fecha_mandato') }}</label>
                <el-form-item prop="fecha">
                  <el-date-picker v-model="form.paymentMethod.fecha" type="date" :format="datePattern" value-format="yyyy-MM-dd" ></el-date-picker>
                </el-form-item>
              </div>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot='RightCol'>
      <slot name="invoice-summary" />
    </template>
    <template slot='layout-extend'>
      <slot name="layout-extend" :valid="isValid" />
    </template>
  </detail-layout-two-columns-no-fixed>
</template>

<script>
import { i18n } from '@/i18n'
import { IBAN as ibanRegex, bicSwift as bicSwiftRegex } from '@/utils/regex'
// import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

// import { getInvoicePayment } from '@/services/app/getInvoicePayment'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { getLastBankAccount } from '@/services/configurations/getLastBankAccount'

import DetailLayoutTwoColumnsNoFixed from '@/components/layout/DetailLayoutTwoColumnsNoFixed.vue'


function isValidIBAN (value) {
  return value.split(';').every(item => ibanRegex.test(item))
}

function isValidBicSwift (value) {
  return value.split(';').every(item => bicSwiftRegex.test(item))
}


export default {
  name: 'step6-issuer',
  components: {
    // Loading,
    DetailLayoutTwoColumnsNoFixed,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      // All
      showModalGrouping: false,
      loadingExcel: false,
      spanish: true,
      showModal: false,
      vuexnamespace: 'invoicesIssuing/6',
      maxLengthIBAN: 40,
      maxLengthBicSwift: 15,
      rules: {
        formaPago: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'] 
          }
        ],
        fecha: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'] 
          }
        ],
        // nombreCuenta: [
        //   { required: false, validator: this.isNameRequired, trigger: ['blur', 'change'] }
        // ],
        iban: [
          { required: true, validator: this.isIBANValid, trigger: ['blur', 'change'] }
        ],
        bicSwift: [
          { required: false, validator: this.isBicSwiftvalid, trigger: ['blur', 'change'] }
        ]
      },
    }
  },
  computed: {
    isValid: function () {
      return true
    },
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    paymentMethod: function () {
      return this.$store.getters['invoicesIssuing/form'].paymentMethod
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    formasPago: function () {
      return this.$store.getters['config/FORMAS_DE_PAGO']
    },
    isRequired: function () {
      return ['02', '04'].includes(this.form.paymentMethod.formaPago)
    },
    isDomiciliado: function () {
      return ['02'].includes(this.form.paymentMethod.formaPago)
    },
    getAuxIdParams: function () {
      return {
        idCIFEmpresa: this.$store.getters['invoicesIssuing/form'].issuer.IdCIFEmpresa,
        idSociedad: this.$store.getters['invoicesIssuing/form'].receiver.IdSociedad,
        idSede: this.$store.getters['invoicesIssuing/form'].receiver.IdSede
      }
      // return params
    }
  },
  async mounted () {
    await this.getLastPaymentMethod()
  },
  methods: {
    getLastPaymentMethod: async function () {
      if (this.paymentMethod.formaPago === '') {
        const data = await getLastBankAccount(this.getAuxIdParams)
        if (data.blnError === true) {
          this.doFeedback(`${data.msgError} [${data.codError}]`)
        }

        this.form.paymentMethod.formaPago = data.respuesta?.PaymentType || ''
        this.form.paymentMethod.iban = data.respuesta?.IBANAccountNumber || ''
        this.form.paymentMethod.bicSwift = data.respuesta?.BIC || ''
        this.form.paymentMethod.fecha = data.respuesta?.MandatoryDate || ''
      }
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.selected[0]?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    isNameRequired: function (rule, value, callback) {
      if (this.form.paymentMethod.nombreCuenta) {
        callback()
      } else if (!value) {
        if (!this.isRequired) {
          callback()
        } else {
          callback(new Error(i18n.t('validation.complete')))
        }
      } 
    },
    isIBANValid: function (rule, value, callback) {
      if (!value && !this.isRequired) {
        callback()
      } else if (this.isRequired) {
        if (!value) {
          callback(new Error(i18n.t('validation.complete')))
        } else if (this.form.paymentMethod.toBeCredit) {
          if (!isValidIBAN(value)) {
            callback(new Error(i18n.t('invoices.invoices_issuing.IBAN_regex')))
          } else if (value.length > this.maxLengthIBAN) {
            callback(new Error((i18n.t('validation.length_max', { maxLength: this.maxLengthIBAN }))))
          } else {
            callback()
          }
        } else {
          // Condiciones de validación para número de cuenta
          callback()
        }
      }
    },
    isBicSwiftvalid: function (rule, value, callback) {
      if (!value) {
        callback()
      } else if (!isValidBicSwift(value)) {
        callback(new Error(i18n.t('invoices.invoices_issuing.swift_regex')))
      } else if (value.length > this.maxLengthBicSwift) {
        callback(new Error((i18n.t('validation.length_max', { maxLength: this.maxLengthBicSwift }))))
      } else {
        callback()
      }
    },
  },
}
</script>
<style scoped>
  .switchCredit{
    margin: unset;
    padding: unset;
  }
</style>
